// project import
import Navigation from "./Navigation";
import SimpleBar from '@/components/third-party/SimpleBar';
import { useSelector } from 'react-redux';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <>
      {/* The nav rail is a fixed-width vertical list — it never legitimately
          needs horizontal scrolling. SimpleBar still creates a horizontal
          track regardless, styled with the shared dark scrollbar color
          (@/components/third-party/SimpleBar.js), which shows up on hover as
          an unwanted dark bar at the bottom of the sidebar. Hide it here
          rather than in the shared component, since other SimpleBar usages
          may legitimately want horizontal scrolling. */}
      <style>{`
        .nav-simplebar .simplebar-track.simplebar-horizontal {
          display: none !important;
        }
      `}</style>
      <SimpleBar
        style={{
          flex: 1,
          height: "100%",
          overflowY: drawerOpen ? "auto" : "visible",
          overflowX: "visible",
          paddingTop: 0,
          marginTop: 0,
        }}
        className="flex flex-col pt-0 mt-0 nav-simplebar"
      >
        {/* Top Content */}
        <Navigation />
      </SimpleBar>
    </>
  );
};

export default DrawerContent;
